import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { CheckIcon, getStatisticsData, whiteLogoImages } from "../constant/economic-card-statistics.constant";

export const EconomicCard = () => {
    const { t } = useTranslation();
    const statisticsData = getStatisticsData(t);
    const [isAnimated, setIsAnimated] = useState(false);
    useEffect(() => {
        setTimeout(() => setIsAnimated(true), 200); // slight delay for effect
    }, []);
    const featuresData = [
        { title: "REGISTRATION_FEATURE_1_TITLE", description: "REGISTRATION_FEATURE_1_DESCRIPTION" },
        { title: "REGISTRATION_FEATURE_2_TITLE", description: "REGISTRATION_FEATURE_2_DESCRIPTION" },
        { title: "REGISTRATION_FEATURE_3_TITLE", description: "REGISTRATION_FEATURE_3_DESCRIPTION" },
        { title: "REGISTRATION_FEATURE_4_TITLE", description: "REGISTRATION_FEATURE_4_DESCRIPTION" },
    ];

    return (
        <div className="registration-info-section">
            <div className="info-card">
                <div className="info-card-content">
                    <div className="partner-logos " >
                        {whiteLogoImages.map((logo, index) => (
                            <div key={index} className="logo-container">
                                {logo.src}
                            </div>
                        ))}
                    </div>
                    <div className="hero-section-registration">
                        <div className="hero-header">
                            <h2 className="hero-title">{t("REGISTRATION_HERO_TITLE_REGISTER")}</h2>
                            <div className="language-toggle">
                                <div className="toggle-switch">
                                    <span className={`toggle-icon ${isAnimated ? ' toggle-icon-animated' : ''}`}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={18}
                                            height={14}
                                            viewBox="0 0 18 14"
                                            fill="none"
                                        >
                                            <path
                                                d="M2 5.5L7.31034 11L16 2"
                                                stroke="#2A214B"
                                                strokeWidth={3}
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <p className="hero-subtitle">{t("REGISTRATION_HERO_SUBTITLE_REGISTER")}</p>
                    </div>

                    <div className="features-list">
                        {featuresData.map((feature, index) => (
                            <div className="feature-item" key={index}>
                                <div className="feature-icon">
                                    <CheckIcon />
                                </div>
                                <div className="feature-content">
                                    <h4>{t(feature.title)}</h4>
                                    <p>{t(feature.description)}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="statistics">
                        {statisticsData.map((stat, index) => (
                            <div className="stat-item" key={index}>
                                <div className="stat-number">{stat.number}</div>
                                <div className="stat-label">{t(stat.label)}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}